import { Platform, StyleSheet } from "react-native";
import { View, Text } from "../../../components/Themed";
import Colors from "../../../constants/Colors";
import { Feather } from "@expo/vector-icons";

export const MainSection = (props: any) => (
  <View
    lightColor={Colors.base_colors_white}
    darkColor={Colors.nuetral_grey_700}
    style={[
      styles.mainSection,
      { paddingVertical: props.isTablet ? 32 : 16 },
      Platform.OS === "web"
        ? {
            marginTop: props.isTablet ? 0 : -16,
            width: "75%",
            alignSelf: "center",
          }
        : null,
    ]}
  >
    {props.children}
  </View>
);

export const StatSection = (props: any) => (
  <View style={styles.statsSection}>{props.children}</View>
);

export const ListSection = (props: any) => (
  <View style={styles.listSection}>{props.children}</View>
);

export const ListHeaderSection = (props: any) => (
  <View style={styles.listHeaderSection}>{props.children}</View>
);

export const ListHeader = ({
  text,
  width,
}: {
  text: string;
  width: number;
}) => (
  <View style={{ flex: width }}>
    <Text lightColor={Colors.nuetral_grey_600}>{text}</Text>
  </View>
);

export const NoLeads = ({ pingTime, startTime, isTablet, completedAt }) => (
  <View style={styles.noLeadsContainer}>
    <View style={styles.noLeadsIconContainer}>
      <Feather
        name={pingTime || startTime ? "users" : "cloud-off"}
        size={42}
        color={Colors.nuetral_grey_700}
      />
    </View>
    <Text
      size={isTablet ? 18 : 16}
      lineHeight={24}
      weight="Bold"
      lightColor={Colors.nuetral_grey_700}
    >
      {pingTime === null && completedAt ? "No Network Connection" : "No Leads"}
    </Text>
    <Text size={16} lightColor={Colors.nuetral_grey_600}>
      {pingTime === null && completedAt
        ? "Connect to network to view data and leads."
        : "We'll start capturing leads as soon as the open house begins!"}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  mainSection: {
    flex: 1,
    paddingVertical: 16,
    gap: 24,
  },
  statsSection: {
    flexDirection: "row",
    gap: 12,
    paddingVertical: 8,
  },
  listSection: {
    flex: 1,
    paddingHorizontal: 16,
  },
  listHeaderSection: {
    flexDirection: "row",
    paddingBottom: 12,
  },
  noLeadsContainer: {
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    paddingVertical: 50,
    borderTopWidth: 1,
    borderTopColor: Colors.tinted_grey_300,
  },
  noLeadsIconContainer: {
    backgroundColor: Colors.nuetral_grey_200,
    padding: 16,
    borderRadius: 100,
  },
});
